import {
  Checkbox,
  Icon,
  ResponsiveVisibility,
  Select,
  Text,
  Skeleton,
  HStack,
} from '@genial/components';
import { Color, Spacing } from '@genial/design-tokens';
import { useBreakpointValue } from '@genial/utils';
import React, { useCallback } from 'react';

import { FundraisingAssetEvolutionPeriodOptions } from '../../../../../../../../store/home/capture/types';
import { periodOptions } from '../../constants';

export namespace PeriodSelectTypes {
  export interface Props {
    periodFilter: FundraisingAssetEvolutionPeriodOptions;
    onSetPeriodFilter: (period: FundraisingAssetEvolutionPeriodOptions) => void;
    visibility?: ResponsiveVisibility;
    loading?: boolean;
  }
}

export const PeriodSelect: React.FC<PeriodSelectTypes.Props> = ({
  visibility,
  loading,
  periodFilter,
  onSetPeriodFilter,
}) => {
  const sanitizedVisibility: NonNullable<ResponsiveVisibility> = visibility ?? {};
  const currentVisibility = useBreakpointValue(
    typeof sanitizedVisibility === 'string' ? { base: sanitizedVisibility } : sanitizedVisibility
  );

  const handleValueChange = useCallback(
    (value: string) => onSetPeriodFilter(value as FundraisingAssetEvolutionPeriodOptions),
    [onSetPeriodFilter]
  );

  const handleCheckboxChange = useCallback(
    (value: string, selected: boolean) => {
      if (selected) {
        onSetPeriodFilter(value as FundraisingAssetEvolutionPeriodOptions);
      }
    },
    [onSetPeriodFilter]
  );

  const select = useBreakpointValue({
    base: (
      <Select
        placeholder="Selecione um período"
        selectedValue={periodFilter}
        options={periodOptions}
        onValueChange={handleValueChange}
        testID="asset-evolution-period-selectt"
      />
    ),
    lg: (
      <Checkbox
        testId="asset-evolution-period-checkbox"
        columns={1}
        options={periodOptions}
        optionPadding={{ right: Spacing['stack.xxxs'] }}
        onChange={handleCheckboxChange}
        selectedValues={[periodFilter]}
        showAsRadio
      />
    ),
  });

  if (currentVisibility === 'hidden') {
    return null;
  }

  if (loading) {
    return (
      <HStack space={Spacing['stack.nano']}>
        <Skeleton height="inset.sm" width="110px" borderRadius="sm" />
      </HStack>
    );
  }

  return (
    <HStack
      alignItems="center"
      justifyContent={{ base: 'space-between', sm: 'flex-start' }}
      space={Spacing['stack.quarck']}>
      <HStack space={Spacing['stack.quarck']} alignItems="center">
        <Icon name="Calendar" size="xxs" color={Color['neutral.medium']} />
        <Text>Período</Text>
      </HStack>
      {select}
    </HStack>
  );
};
